export enum MATRIX_LS_ITEM {
  PERSONAL = 'matrix-personal',
  SKILLS = 'matrix-skills',
  ADDITIONAL = 'matrix-additional',
}
